"use client";

import React, { useEffect, useState, useCallback } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import {
  Envelope,
  InfoCircle,
  Lock,
  FileText,
} from "react-bootstrap-icons";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { TermsOfUse } from "./terms";
import { PrivacyPolicy } from "./privacy";

const ContactsSection = () => (
  <div id="contacts">
    <h2 className="mb-3">Контакты</h2>
    {/* <div className="mb-2">E-mail: <Link to="mailto:info@factfactor.ru">info@factfactor.ru</Link></div>
    <div className="mb-2">Телефон: 8 (912) 345-67-89</div> */}
    {/* <div className="mb-2">ИНН: 2301117849</div> */}
    {/* <div className="mb-2">ОГРН: 1252300042026</div> */}
    {/* <div className="mb-2">АО «Феникс Интернешнл»</div> */}
    По всем вопросам, связанным с Приложением, вы можете обратиться по электронной почте: <Link to="mailto:info@factfactor.ru">info@factfactor.ru</Link>
  </div>
);

const getIconForSection = (id: string) => {
  switch (id) {
    case "contacts": return <Envelope size={18} className="me-2" />;
    case "terms": return <FileText size={18} className="me-2" />;
    case "privacy": return <Lock size={18} className="me-2" />;
    default: return <InfoCircle size={18} className="me-2" />;
  }
};

const Card = ({ children }: { children: React.ReactNode }) => (
  <div
    className="rounded-5"
    style={{
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.21)",
      padding: "18px 16px",
      marginBottom: 20,
    }}
  >
    {children}
  </div>
);

const AnimatedCard = ({
  isOpen,
  children,
}: {
  isOpen: boolean;
  children: React.ReactNode;
}) => {
  const contentRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = React.useState<number | "auto">("auto");

  React.useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        // Сначала сбросим высоту, чтобы измерить реальную высоту контента
        contentRef.current.style.height = "auto";
        const scrollHeight = contentRef.current.scrollHeight;
        contentRef.current.style.height = "0px";
        // Запускаем переход
        requestAnimationFrame(() => {
          contentRef.current!.style.height = `${scrollHeight}px`;
        });
      } else {
        contentRef.current.style.height = "0px";
      }
    }
  }, [isOpen]);

  return (
    <div
      ref={contentRef}
      className="px-2"
      style={{
        height: isOpen ? "auto" : "0px", // только для начального состояния
        overflow: "hidden",
        transition: "height 0.3s ease",
        // убираем padding/margin из корня — переносим внутрь
      }}
    >
      <div
        className="rounded-5"
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.21)",
          padding: "18px 16px",
          marginBottom: isOpen ? 20 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};

const Info = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [openSection, setOpenSection] = useState<string | null>(null);

  const handleNavClick = useCallback((id: string) => {
    if (isMobile) {
      if (openSection === id) {
        setOpenSection(null);
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      } else {
        setOpenSection(id);
        window.history.replaceState(null, "", `#${id}`);
      }
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.replaceState(null, "", `#${id}`);
      }
    }
  }, [isMobile, openSection]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash) {
        if (isMobile) {
          setOpenSection(hash);
        } else {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [isMobile]);

  const sections = [
    { id: "contacts", label: "Контакты" },
    { id: "terms", label: "Условия поьзования" },
    { id: "privacy", label: "Конфиденциальность" },
  ];

  const sectionComponents: Record<string, React.ReactNode> = {
    contacts: <ContactsSection />,
    terms: <TermsOfUse />,
    privacy: <PrivacyPolicy />,
  };

  return (
    <>
      <Container fluid className="py-2 px-3 px-md-4">
        <h1 className="text-center mb-3">Информация</h1>

        <Row>
          {!isMobile && (
            <Col md={3}>
              <div
                className="rounded-5"
                style={{
                  background: "#fff",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
                  padding: "20px",
                  position: "sticky",
                  top: "20px",
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                }}
              >
                <Nav className="flex-column">
                  {sections.map((section) => (
                    <Nav.Link
                      key={section.id}
                      href={`#${section.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavClick(section.id);
                      }}
                      className="d-flex align-items-center py-2 px-3 rounded mb-2"
                      style={{
                        userSelect: "none",
                        color: "#555",
                        textDecoration: "none",
                        fontSize: "14px",
                        transition: "all 0.2s ease",
                        fontWeight: 500,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                        e.currentTarget.style.color = "#222";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#555";
                      }}
                    >
                      {getIconForSection(section.id)}
                      {section.label}
                    </Nav.Link>
                  ))}
                </Nav>
              </div>
            </Col>
          )}

          <Col xs={12} md={9}>
            {isMobile ? (
              <div
                style={{
                  maxHeight: "calc(100vh - 120px)",
                  overflowY: "auto",
                  paddingRight: 4,
                }}
                className="scrollbar-custom-y"
              >
                {sections.map((section) => (
                  <div key={section.id}>
                    <button
                      className="w-100 text-start d-flex align-items-center py-3 px-3 rounded-3 border-0 bg-light mb-2"
                      style={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#222",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                      }}
                      onClick={() => handleNavClick(section.id)}
                    >
                      {getIconForSection(section.id)}
                      {section.label}
                    </button>
                    <AnimatedCard isOpen={openSection === section.id}>
                      {sectionComponents[section.id]}
                    </AnimatedCard>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="scrollbar-custom-y"
                style={{
                  overflowY: "auto",
                  position: "relative",
                  scrollBehavior: "smooth",
                  height: "calc(100vh - 160px)",
                  padding: "10px",
                }}
              >
                {sections.map((section) => (
                  <Card key={section.id}>{sectionComponents[section.id]}</Card>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Info;